import React from 'react';
import './styles.scss';

const PipPlayer = ({ videoTagRef }) => {
  return (
    <video ref={videoTagRef} id="pip-video" controls={false} autoPlay></video>
  )
}

export default PipPlayer;
